import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController } from '@ionic/angular';
import { GlobalService } from '../services/global.service';
import { ApiService } from '../services/api.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';



@Component({
  selector: 'app-addsoundfile',
  templateUrl: './addsoundfile.page.html',
  styleUrls: ['./addsoundfile.page.scss'],
})
export class AddsoundfilePage implements OnInit {



  addSoundTextForm !: FormGroup;

  formData = {
    message: '',
    lang: 'prioritize_text',
    type: 'text',
    isForInterpretation: false,
    audioFile: null
  };
  

  constructor(private fb: FormBuilder,private http: HttpClient,private alertController: AlertController,private apiService:ApiService,private router:Router,private globalService:GlobalService) { }

  ionViewWillLeave() {
    console.log('localStorage from Add Text Page cleared when leaving the page');
  }
  ngOnInit() {
    this.initializeForm();

   
  }

  initializeForm() {
  
    this.addSoundTextForm = this.fb.group({
      message: ['', [Validators.required]],    
      lang: ['nl', [Validators.required]],   
      type: ["text", [Validators.required]],
      isForInterpretation: [false, [Validators.required]],
      audioFile: [null, [Validators.required]]  // For file selection
    });
  }

  goToMenu() {
    this.router.navigate(['/menu']);
  }

  ionViewWillEnter() {
    this.resetForm();
  }

  
  onToggleChange(event: any) {
    const isChecked = event.detail.checked;
    console.log('Toggle changed:', isChecked);
  
    this.addSoundTextForm.patchValue({ isForInterpretation: isChecked });
  }

  onFileSelected(event: Event) {
    console.log("File selected")
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];
      this.addSoundTextForm.patchValue({ audioFile: file });
    }
  }

  async confirmLogout() {
      const alert = await this.alertController.create({
            header: 'Confirm Logout',
            message: 'Are you sure you want to log out?',
            buttons: [
                {
                    text: 'Cancel',
                    role: 'cancel',
                    handler: () => {
                        // Do nothing when the user cancels
                    }
                },
                {
                    text: 'Logout',
                    handler: async () => {
                        // this.stopRecordingOnly();
                        await this.LogoutFunction();
                    }
                }
            ]
        });

        await alert.present();
      // }else{
      //   await this.LogoutFunction();
      // }
  }

  async LogoutFunction(){
  
      try{
          this.globalService.logoutLoading();
          const res:any = await this.apiService.logoutUser().toPromise();
              

          localStorage.removeItem('authenticationKey');
          localStorage.removeItem('accent');
          localStorage.removeItem('age');
          localStorage.removeItem('gender');
          localStorage.removeItem('userId');
          localStorage.removeItem('userName');
          localStorage.removeItem('language');

          localStorage.removeItem('searchedText');
          localStorage.removeItem('selectedModel');
          localStorage.removeItem('selectedModelLanguageForTTS');
          localStorage.removeItem('selectedOptionUser');
          localStorage.removeItem('textCategory');
          localStorage.removeItem('totalCountData');
          localStorage.removeItem('usersList');
          localStorage.removeItem('userRole');

          this.globalService.dismissLoading();
        
          this.router.navigate(['login']);



        
      
      }catch(error){
        console.log("Error:", error);
        // this.globalService.dismissLoading();
        this.router.navigate(['login']);

      }
      
  };


  onSubmit(){
    try{
      this.globalService.logoutLoading();
      if (this.addSoundTextForm.valid) {
        // const formData = this.addSoundTextForm.value;

        const formValue = this.addSoundTextForm.value;
        const formData = new FormData();

        formData.append('AudioFile', formValue.audioFile);
        const TextInfo = {
          Text: formValue.message,
          Type: formValue.type,
          Language: formValue.lang,
        };
        formData.append('TextInfo', JSON.stringify(TextInfo));
        formData.append('IsForInterpretation', formValue.isForInterpretation.toString());







        this.apiService.addTextWithAudio(formData).subscribe(response => {
          console.log('Text With Audio added successfully!!!', response);
          this.resetForm();
        }, error => {
          console.error('Adding Text error:', error);
        });



      }
      this.globalService.dismissLoading();
    }catch(error){
      console.log('Form is invalid');
    }
  }

  resetForm() {
    
    

    this.addSoundTextForm.reset({
      message: '',
      lang: 'nl',
      type: 'text',
      isForInterpretation: false,
      audioFile: null

    });

    // Clear the file input manually
    const fileInput = document.querySelector('input[type="file"]') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }

    

  }
  



}

